<template>
  <img
    class="vb-img"
    :src="data.src"
    :draggable="draggable"
    :class="{ selected: selectedPath == path }"
    @load="(ev) => $emit('update')"
    @click.stop="$emit('select', path)"
    @dragstart.stop="$emit('toDrag', path)"
    @dragover.stop="$event.preventDefault()"
    @drop.stop="$emit('toDrop', path)"
    v-if="!!data.src"
  />
  <div
    class="vb-img-empty"
    :class="{ selected: selectedPath == path }"
    :draggable="draggable"
    @click.stop="$emit('select', path)"
    @dragstart.stop="$emit('toDrag', path)"
    @dragover.stop="$event.preventDefault()"
    @drop.stop="$emit('toDrop', path)"
    v-else
  >
    <strong>IMG</strong>
  </div>
</template>
<script>
  export default {
    name: 'vb-img',
    props: {
      data: {
        required: true
      },
      path: {
        required: true
      },
      draggable: {
        type: Boolean
      },
      selectedPath: {
        type: String
      }
    }
  }
</script>
<style lang="scss" scoped>
  .vb-img-empty {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    height: 2rem;
    border: .2rem dashed brown;

    &.selected {
      border: .2rem dashed red;
    }
  }

  .vb-img {
    max-width: 100%;

    &.selected {
      border: .2rem dashed red;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/VirtualBookViewer/VirtualBookImage.vue